import React from 'react';
import { ArrowRight, Clock, Shield, Zap } from 'lucide-react';
import { useBooking } from '../../BookingContext';
import LadiesImage from "../../assets/image ladies.jpg";

const stats = [
  { icon: <Shield size={18} />, k: '1800+', v: 'Happy Customers' },
  { icon: <Clock size={18} />, k: '12hr', v: 'Turnaround' },
  { icon: <Zap size={18} />, k: '4.8★', v: 'Avg Rating' },
];

export default function Hero() {
  const { open: onBook } = useBooking();
  return (
    <section
      id="home"
      className="relative pt-28 md:pt-36 pb-16 md:pb-24 overflow-hidden">
      <div className="hero-blob w-[420px] h-[420px] bg-pink-300 -top-24 -left-24" />
      <div className="hero-blob w-[500px] h-[500px] bg-pink-200 top-32 -right-24" />

      <div className="relative max-w-7xl mx-auto px-5 md:px-8 grid lg:grid-cols-2 gap-10 lg:gap-14 items-center">
        {/* Left */}
        <div className="animate-fadeUp">
          <div className="inline-flex items-center gap-2 rounded-full bg-pink-50 text-[#E91E80] px-4 py-1.5 text-xs font-semibold border border-pink-100">
            <Zap size={14} /> India's First Quick Clothing Services
          </div>
          <h1
            className="mt-5 font-extrabold leading-[1.05] tracking-tight text-slate-900"
            style={{
              fontFamily: "'Poppins', sans-serif",
              fontSize: "clamp(2.4rem, 5vw, 4rem)",
            }}>
            India's <span className="zp-gradient-text">First Quick</span>
            <br />
            <span className="zp-gradient-text">Clothing</span> Services
          </h1>
          <br />
          <h1
            className="mt-5 font-extrabold leading-[1.05] tracking-tight text-slate-900"
            style={{
              fontFamily: "'Poppins', sans-serif",
              fontSize: "clamp(2.4rem, 5vw, 4rem)",
            }}>
            <span className="zp-gradient-text">Pickup in</span> 10Mins
          </h1>
          <br />
          <p className="mt-5 text-slate-600 text-lg leading-relaxed max-w-xl">
            Redefining clothing care with speed, quality, and doorstep service.
            Seamless experience, flawless results — every time.
          </p>
          <p className="mt-3 text-slate-500 italic">
            Effortless Style, Delivered Fast.
          </p>

          <div className="mt-8 flex flex-wrap items-center gap-4">
            <button
              onClick={onBook}
              className="zp-pill-btn inline-flex items-center gap-2">
              Schedule Pickup <ArrowRight size={18} />
            </button>
            <a
              href="#how"
              className="zp-outline-btn inline-flex items-center gap-2">
              How it Works
            </a>
          </div>

          <div className="mt-10 grid grid-cols-3 gap-4 max-w-lg">
            {stats.map((s) => (
              <div
                key={s.v}
                className="rounded-2xl bg-white/70 backdrop-blur border border-pink-100 p-3.5">
                <div className="text-[#E91E80]">{s.icon}</div>
                <div className="mt-1 text-lg font-bold text-slate-900">
                  {s.k}
                </div>
                <div className="text-xs text-slate-500">{s.v}</div>
              </div>
            ))}
          </div>
        </div>

        {/* Right */}
        <div className="relative animate-fadeUp">
          <div className="relative rounded-[32px] overflow-hidden shadow-2xl shadow-pink-200/50 border-8 border-white">
            <img
              src={LadiesImage}
              alt="Zoopers premium clothing care"
              className="w-full md:h-[560px] object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/25 via-transparent to-transparent" />
          </div>

          {/* Floating badge: delivery */}
          <div className="absolute -left-4 md:-left-10 top-16 rounded-2xl bg-white shadow-xl px-4 py-3 flex items-center gap-3 animate-floaty border border-pink-50">
            <div className="h-10 w-10 rounded-xl bg-pink-100 text-[#E91E80] grid place-items-center">
              <Clock size={18} />
            </div>
            <div>
              <div className="text-xs text-slate-500">Delivered in</div>
              <div className="text-sm font-semibold text-slate-900">
                12 hours
              </div>
            </div>
          </div>

          {/* Floating badge: verified */}
          <div
            className="absolute -right-4 md:-right-10 bottom-16 rounded-2xl bg-white shadow-xl px-4 py-3 flex items-center gap-3 animate-floaty border border-pink-50"
            style={{ animationDelay: "1s" }}>
            <div className="h-10 w-10 rounded-xl bg-orange-100 text-orange-500 grid place-items-center">
              <Shield size={18} />
            </div>
            <div>
              <div className="text-xs text-slate-500">Verified</div>
              <div className="text-sm font-semibold text-slate-900">
                Women Experts
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
